/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Payments_Tab_SubscriptionInputs */

const en_admin_payments_tab_subscription = /** @type {(inputs: Admin_Payments_Tab_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscription`)
};

const zh_admin_payments_tab_subscription = /** @type {(inputs: Admin_Payments_Tab_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`订阅`)
};

/**
* | output |
* | --- |
* | "Subscription" |
*
* @param {Admin_Payments_Tab_SubscriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_payments_tab_subscription = /** @type {((inputs?: Admin_Payments_Tab_SubscriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Payments_Tab_SubscriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_payments_tab_subscription(inputs)
	return zh_admin_payments_tab_subscription(inputs)
});
export { admin_payments_tab_subscription as "admin.payments.tab_subscription" }